import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.groups
)

export const selectUsersGroups = createSelector(
    baseSelector,
    (state) => state.usersGroups
)
export const selectUsersGroupsError = createSelector(
    baseSelector,
    (state) => state.usersGroupsError
)
export const selectUsersGroupsLoading = createSelector(
    baseSelector,
    (state) => state.isUsersGroupsLoading
)
export const selectEmployeesGroups = createSelector(
    baseSelector,
    (state) => state.employeesGroups
)
export const selectEmployeesGroupsError = createSelector(
    baseSelector,
    (state) => state.employeesGroupsError
)
export const selectEmployeesGroupsLoading = createSelector(
    baseSelector,
    (state) => state.isEmployeesGroupsLoading
)